import { createFileRoute } from "@tanstack/react-router"

import { HomeCompaniesCard } from "@/components/partners/HomeCompaniesCard"
import { HomeGuideCard } from "@/components/partners/HomeGuideCard"
import { HomeNewClientCard } from "@/components/partners/HomeNewClientCard"
import { HomeReferralsCard } from "@/components/partners/HomeReferralsCard"
import { ReferralLinkCard } from "@/components/partners/ReferralLinkCard"

export const Route = createFileRoute("/_dashboard/partners/home")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="grid gap-6">
      <div className="grid grid-cols-1 gap-6 [&>*]:min-w-0">
        <ReferralLinkCard />
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 [&>*]:min-w-0">
        <HomeReferralsCard />
        <HomeNewClientCard />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 [&>*]:min-w-0">
        <HomeGuideCard />
        <HomeCompaniesCard />
      </div>
    </div>
  )
}
